import { ControlValueAccessor } from '@angular/forms';

export class BaseControlValueAccessor<T> implements ControlValueAccessor {
    public disabled = false;
    public _value: T;
    public get value(): T { return this._value; }
    public set value( value: T ) {
        this.onChange(value);
        this._value = value;
    }

    /**
     * Call when value has changed programmatically
     */
    public onChange = (_: any) => {};
    public onTouched = () => {};

    public constructor(initialValue?: T) {
        if (initialValue) {
            this.value = initialValue;
        }
    }

    /**
     * Model -> View changes
     */
    public writeValue(obj: T): void { this._value = obj; }
    public registerOnChange(fn: any): void { this.onChange = fn; }
    public registerOnTouched(fn: any): void { this.onTouched = fn; }
    public setDisabledState?(isDisabled: boolean): void { this.disabled = isDisabled; }
}
